import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "sum" };
const _hoisted_2 = { class: "item__amount" };
const _hoisted_3 = { class: "item__tax-amount" };
const _hoisted_4 = { class: "item__total-amount" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BarogoTooltip = _resolveComponent("BarogoTooltip");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_StoreAdjustmentHistoryListRow = _resolveComponent("StoreAdjustmentHistoryListRow");
    const _component_v_data_table = _resolveComponent("v-data-table");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createBlock(_component_v_card, { class: "mt-2 brg-card-outlined" }, {
        default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "list-title font-weight-medium" }, {
                default: _withCtx(() => [
                    _createVNode(_component_BarogoTooltip, null, {
                        activatorSlot: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}provide_history`)), 1 /* TEXT */)
                        ]),
                        tooltipMessage: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}provide_history_tooltip`)), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_data_table, {
                hover: "",
                class: "store-adjustment-detail-table brg-table brg-table-in-card",
                headers: _ctx.tableHeaders,
                "hide-default-footer": "",
                items: _ctx.getterStoreAdjustmentDetailList,
                "fixed-header": ""
            }, {
                [`item`]: _withCtx(({ item }) => [
                    _createVNode(_component_StoreAdjustmentHistoryListRow, { list: item }, null, 8 /* PROPS */, ["list"])
                ]),
                "body.append": _withCtx(() => [
                    _createElementVNode("tr", _hoisted_1, [
                        _cache[0] || (_cache[0] = _createElementVNode("th", { class: "item_name" }, " 총 ", -1 /* CACHED */)),
                        _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.sumAmount), 1 /* TEXT */),
                        _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.sumTaxAmount), 1 /* TEXT */),
                        _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.sumTotalAmount), 1 /* TEXT */),
                        _cache[1] || (_cache[1] = _createElementVNode("th", null, _toDisplayString('-'), -1 /* CACHED */))
                    ])
                ]),
                bottom: _withCtx(() => _cache[2] || (_cache[2] = [])),
                _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["headers", "items"])
        ]),
        _: 1 /* STABLE */
    }));
}
